import type { ChainedCommands } from "@tiptap/core"
import type { Editor } from "@tiptap/react"
import type { RichTextToolbarOption } from "../types"

export type NormalizedToolbarOption =
  | "codeBlock"
  | "inlineCode"
  | "textLevel"
  | "bold"
  | "italic"
  | "strikethrough"
  | "unorderedList"
  | "orderedList"
  | "indentList"
  | "outdentList"
  | "link"
  | "image"
  | "attachment"
  | "embed"
  | "textColor"
  | "highlight"
  | "subscript"
  | "superscript"

export type InsertionToolbarOption = Extract<
  NormalizedToolbarOption,
  "image" | "attachment" | "embed"
>

export type EditorChain = ReturnType<Editor["chain"]> & ChainedCommands

export const DEFAULT_TOOLBAR_OPTIONS: RichTextToolbarOption[] = [
  "areaCode",
  "inlineCode",
  "textLevel",
  "bold",
  "italic",
  "strikethrough",
  "unorderedList",
  "orderedList",
  "indentList",
  "outdentList",
  "link",
  "image",
  "attachment",
  "embed",
  "textColor",
  "highlight",
  "subscript",
  "superscript"
]

export function normalizeToolbarOption(
  option: RichTextToolbarOption
): NormalizedToolbarOption {
  if (option === "areaCode") return "codeBlock"
  if (option === "textStyle") return "textLevel"
  if (option === "supscript") return "subscript"
  return option
}

export function isInsertionToolbarOption(
  option: NormalizedToolbarOption
): option is InsertionToolbarOption {
  return option === "image" || option === "attachment" || option === "embed"
}
